var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('FingerprintAuthorisation',{attrs:{"required":"","label":"Fingerprint (Required)"},model:{value:(_vm.fingerprint),callback:function ($$v) {_vm.fingerprint=$$v},expression:"fingerprint"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }